/* istanbul ignore file: Directive */
'use strict';

/**
 * A directive that, when its value evaluates to a truthy value, shows a loading-indicator over its element.
 * If placed on a table, the loading indicator is added as a row at the bottom.
 **/
customerZone.directive('loading', [function(){

    return {

        link: function(scope, elem, attrs){

            var createIndicator = function(parent) {
                var loadingValue = scope.$eval(attrs.loading);
                var message = typeof loadingValue === 'string' ? loadingValue : '&nbsp';
                if (parent.is('table')) {
                    var colSpan = parent.find('> tr, > tbody > tr, > thead > tr').last().find('> td, > th').length;
                    if (colSpan === 0) colSpan = 1;
                    return $('<tr class="busy-indicator"><td colspan="' + colSpan + '">' + message + '</td></tr>');
                }
                else {
                    return $('<span class="busy-indicator">' + message + '</span>');
                }
            };

            var addLoadingIndicator = function(elem){
                elem.addClass('loading');
                var indicator = createIndicator(elem);
                if (elem.children('tbody').length > 0) {
                    elem.children('tbody').append(indicator);
                }
                else if (elem.children().first().is('h1, h2, h3, h4, h5, h6')) {
                    elem.children().first().after(indicator);
                }
                else {
                    elem.prepend(indicator);
                }
            };

            var removeLoadingIndicator = function(elem){
                elem.find('.busy-indicator').remove();
                elem.removeClass('loading');
            };

            scope.$watch(attrs.loading, function(){
                var loading = scope.$eval(attrs.loading);
                if (loading && !elem.is('.loading'))
                    addLoadingIndicator(elem);
                if (!loading && elem.is('.loading'))
                    removeLoadingIndicator(elem);
            });
        }
    };
}]);
